<template>
  <div class="page-container">
    <div class="nav-wrap">
      <div class="logo-wrap">
        <a href="/"><img class="logo" src="../../assets/repechage-logo-black.png" alt="repechage"></a>
      </div>
      <div class="nav-item-list">
        <div class="nav-item">
          <a href="/">回到主页</a>
        </div>
        <div class="nav-item">
          <a href="/admin/goods">商品管理</a>
        </div>
        <div class="nav-item">
          <a href="/admin/members">会员管理</a>
        </div>
        <div class="nav-item">
          <div class="dropdown-btn">新闻资讯管理</div>
          <div class="dropdown-content">
            <a href="/admin/blog_list">新闻资讯列表</a>
            <a href="/admin/new_blog">添加资讯</a>
            <a href="/admin/redbook_list">小红书列表</a>
          </div>
        </div>
      </div>
      <div class="nav-right">
        <div class="nav-item user-item">
          <div class="dropdown-btn user-name">{{userInfo.name}}</div>
          <div class="dropdown-content user-content">
            <router-link to="/my/zone">个人中心</router-link>
            <router-link to="/admin/members" v-if="userInfo.role === 1">管理后台</router-link>
            <router-link to="/login">退出登录</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showGoods: false,
      user: {
        role: 0
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user
    }
  },
  methods: {
    goto (url) {
      this.showGoods = false
      this.$router.push(url)
    },
    getStaffInfo () {
      const user = sessionStorage.getItem('user')
      if (user !== null) {
        this.user = JSON.parse(user)
        this.$store.commit('updateUserInfo', { user: this.user })
      }
    }
  },
  mounted () {
    this.getStaffInfo()
  }
}
</script>

<style scoped>
a{
  text-decoration: none;
  color: #25282a;
  display: block;
}
.page-container{
  width: 100%;
}
.nav-wrap{
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.nav-item-list{
  height: 100%;
  flex: 1;
  max-width: 1200px;
}
.nav-item{
  height: 65px;
  line-height: 65px;
  margin: 0 3%;
  font-size: 16px;
  box-sizing: border-box;
  font-weight: 300;
  font-style: normal;
  text-transform: none;
  color: #25282a;
  border-bottom: 1px solid #fff;
  position: relative;
  display: inline-block;
}
.nav-item:hover{
  border-bottom: 1px solid #000;
}
.nav-item:hover .dropdown-content {
    display: block;
}
.nav-item:hover .user-content {
  right: 0;
}
.logo-wrap{
  padding: 10px 55px;
}
.logo{
  height: 45px;
}
.dropdown-content {
  box-sizing: border-box;
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 200px;
  line-height: 50px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
}
.dropdown-content a {
  padding: 0 15px;
}
.dropdown-content a:hover {
  background-color: #f1f1f1
}
.nav-right{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  font-size: 15px;
}
.search-wrap{
  border: 1px solid #DCDFE6;
  padding: 2px 1px 2px 5px;
  border-radius: 3px;
}
.search-input{
  padding: 5px 1px 5px 5px;
  border: none;
  outline: none;
  font-size: 12px;
}
.login{
  cursor: pointer;
}
.user-name{
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
